module.exports = __webpack_public_path__ + "static/media/univ.b9879c02.png";